module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Text-width-f6a522934efa8a5c63fe08a6d47c2bcd.svg";